import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

export const billingService = {
    createSubscription,
    updateSubscription,
    createCustomerPortal,
    getUpdateSubscriptionData,
    getDirectoriesAddOns,
    previewDirectoriesAddOn,
    enrollDirectoriesAddOn,
    cancelDirectoriesAddOn,
};

function createSubscription(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/stripe/create-subscription`, requestOptions).then(handleResponse);
}

function updateSubscription(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/stripe/update-subscription`, requestOptions).then(handleResponse);
}

function createCustomerPortal(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/stripe/create-customer-portal`, requestOptions).then(handleResponse);
}

function getUpdateSubscriptionData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/stripe/subscription-proration`, requestOptions).then(handleResponse);
}

function getDirectoriesAddOns() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/billing/addons/directories`, requestOptions).then(handleResponse);
}

function previewDirectoriesAddOn(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/billing/addons/directories:preview`, requestOptions).then(handleResponse);
}

function enrollDirectoriesAddOn(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/billing/addons/directories:enroll`, requestOptions).then(handleResponse);
}

function cancelDirectoriesAddOn(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/billing/addons/directories:cancel`, requestOptions).then(handleResponse);
}
